import { axiosAction } from '../../utils/axiosAction';
import { constructSearchObj } from '../../utils/utils';
import {
  CATEGORIES_CREATE_CATEGORY,
  CATEGORIES_EDIT_CATEGORY,
  CATEGORIES_FETCH_ALL_CATEGORIES_CATALOG,
  CATEGORIES_FETCH_CATEGORIES,
  CATEGORIES_FETCH_CATEGORIES_BY_NAME,
  CATEGORIES_FETCH_CATEGORIES_CATALOG,
  CATEGORIES_SET_PAGE,
  CATEGORIES_SET_ROWS_PER_PAGE,
  CATEGORY_CLEAR_PAGINATION_INFO,
} from '../action-types/categories-types';

const ENDPOINT_FETCH = `${process.env.REACT_APP_ENDPOINT_CATEGORIES}`;
const ENDPOINT_CREATE = `${process.env.REACT_APP_ENDPOINT_EQUIPMENT_CATEGORIES}`;

export const getEntities = (params, meta?) => async dispatch => {
  return axiosAction.get(
    ENDPOINT_FETCH,
    CATEGORIES_FETCH_CATEGORIES,
    dispatch,
    { params, meta },
  );
};

export const getAllEntitiesCatalog =
  (params = {}, meta?) =>
  async dispatch => {
    return axiosAction.getAll(
      ENDPOINT_FETCH,
      CATEGORIES_FETCH_ALL_CATEGORIES_CATALOG,
      dispatch,
      params,
      {
        meta,
      },
    );
  };

export const getEntitiesCatalog = searchObj => async dispatch => {
  const endpoint = `${ENDPOINT_FETCH}${constructSearchObj(searchObj)}`;
  return axiosAction.get(
    endpoint,
    CATEGORIES_FETCH_CATEGORIES_CATALOG,
    dispatch,
  );
};

export const getEntitiesByName =
  (brand, name = '') =>
  async dispatch => {
    const endpoint = `${ENDPOINT_FETCH}${constructSearchObj({
      brand,
      limit: 100,
      isActive: 1,
      name,
    })}`;
    return axiosAction.get(
      endpoint,
      CATEGORIES_FETCH_CATEGORIES_BY_NAME,
      dispatch,
    );
  };

export const createCategory = category => async dispatch => {
  return axiosAction.post(
    ENDPOINT_CREATE,
    CATEGORIES_CREATE_CATEGORY,
    dispatch,
    category,
  );
};

export const editCategory = (idCategory, objToEdit) => async dispatch => {
  return axiosAction.patch(
    `${ENDPOINT_CREATE}/${idCategory}`,
    CATEGORIES_EDIT_CATEGORY,
    dispatch,
    objToEdit,
  );
};

export const setRowsPerPageAction = payload => ({
  type: CATEGORIES_SET_ROWS_PER_PAGE,
  payload,
});

export const setPageAction = payload => ({
  type: CATEGORIES_SET_PAGE,
  payload,
});

export const clearPaginationInfo = () => ({
  type: CATEGORY_CLEAR_PAGINATION_INFO,
});
